import { render, staticRenderFns } from "./IncomeSources.vue?vue&type=template&id=1c822040&"
import script from "./IncomeSources.vue?vue&type=script&lang=js&"
export * from "./IncomeSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports